import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faFilePdf,
	faChartPie,
	faScroll,
	faCopy,
	faCheck,
	faClose,
	faHourglass,
	faCirclePlus,
} from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'
import CreateProposalModal from './CreateProposalModal/index.vue'
import api from '@/helpers/fetch'
import { genId } from '@/helpers/gen-id'

library.add(
	faFilePdf,
	faClose,
	faScroll,
	faCopy,
	faCheck,
	faHourglass,
	faCirclePlus,
)

@Component({
	components: {
		Loader,
		vSelect,
		CreateProposalModal,
	},
})
export default class Proposals extends Vue {
	proposals = [] as Array<any>

	loading = false

	async updateStatus(proposal, status) {
		proposal.loading = true
		const res = await api.post(
			`/api/my-account/proposals/${proposal.id}/status`,
			{
				status,
			},
		)
		if (res.ok) {
			proposal.status = status
			proposal.updated_at = new Date()
		}
		proposal.loading = false
	}

	openPDF(id) {
		const api = process.env.VUE_APP_URL || 'http://192.168.10.10:8734'
		window.open(`/api/my-account/proposals/${id}/pdf`, '_blank')
	}

	duplicate(proposal) {
		// @ts-ignore
		this.$refs.createModal.setForm(proposal)
		this.$bvModal.show('create-proposal')
	}

	getDateString(str) {
		const [year, month, day] = new Date(str)
			.toISOString()
			.split('T')[0]
			.split('-')

		return `${day}/${month}/${year}`
	}

	async loadProposals() {
		this.loading = true
		this.proposals.length = 0
		const res = await api.get('/api/my-account/proposals')
		res.data.forEach((proposal) => {
			proposal.loading = false
			proposal.proposals_subjects = proposal.proposals_subjects.map(
				(subject) => {
					subject.htmlId = genId()
					return subject
				},
			)
		})

		this.proposals.push(...res.data)
		this.loading = false
	}

	mounted() {
		this.loadProposals()
	}
}
